import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled from '@emotion/styled';
import RenderTextField from '../../../../components/TextField/RenderTextField';

const DadosPagamentoAlternativoForm = ({ dados, onChange }) => {
  const handleChange = (campo, value) => {
    onChange({ ...dados, [campo]: value });
  };

  return (
    <Grid container spacing={2}>
      <FormGroup item xs={12}>
        <RenderTextField
          label="Slug *"
          field={dados.slug || ''}
          handleChange={(e) => handleChange('slug', e.target.value)}
        />
      </FormGroup>
      <FormGroup item xs={12}>
        <RenderTextField
          label="Wallet ID"
          field={dados.walletId || ''}
          handleChange={(e) => handleChange('walletId', e.target.value)}
        />
      </FormGroup>
      <FormGroup item xs={12}>
        <RenderTextField
          label="Percentual de Repasse"
          field={dados.percentualRepasse ?? ''}
          type="number"
          handleChange={(e) => handleChange('percentualRepasse', e.target.value ? Number(e.target.value) : null)}
        />
      </FormGroup>
    </Grid>
  );
};

const FormGroup = styled(Grid)`
  margin-bottom: 8px !important;
`;

export default DadosPagamentoAlternativoForm;
